import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from 'src/app/components/login/login.component';
import { LogoutComponent } from 'src/app/components/logout/logout.component';
import { HomeComponent } from './components/home/home.component';
import { SignupComponent } from './components/signup/signup.component';
import { MainComponent } from './components/main/main.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { CampaignsComponent } from './components/campaigns/campaigns.component';
import { EditComponent as CampaignEditComponent } from './components/campaigns/edit/edit.component';
import { RecentComponent as CampaignRecentComponent } from './components/campaigns/recent/recent.component';
import { SearchComponent as CampaignSearchComponent } from './components/campaigns/search/search.component';
import { PlacementsComponent } from './components/placements/placements.component';
import { RecentComponent as PlacementRecentComponent } from './components/placements/recent/recent.component';
import { SearchComponent as PlacementSearchComponent } from './components/placements/search/search.component';
import { EditComponent as PlacementEditComponent } from './components/placements/edit/edit.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UsersComponent } from './components/settings/users/users.component';
import { EditComponent as UsersEditComponent } from './components/settings/users/edit/edit.component';
import { BillingComponent } from './components/settings/billing/billing.component';
import { OrganizationComponent } from './components/settings/organization/organization.component';

const routes: Routes = [
  { path: 'signup', title: $localize`Signup`, component: SignupComponent },
  { path: 'login', title: $localize`Login`, component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  {
    path: '', component: MainComponent, children: [
      { path: '', title: $localize`Main`, component: HomeComponent },
      { path: 'categories/:categoryId', title: $localize`Categories`, component: CategoriesComponent },

      { path: 'campaigns', component: CampaignsComponent, children: [
        { path: '', title: $localize`Campaigns`, component: CampaignRecentComponent },
        { path: 'search', title: $localize`Campaign search`, component: CampaignSearchComponent },
        { path: ':campaignId', title: $localize`Campaign`, component: CampaignEditComponent },
      ]},
      { path: 'placements', component: PlacementsComponent, children: [
        { path: '', title: $localize`Product placements`, component: PlacementRecentComponent },
        { path: 'search', title: $localize`Product placement search`, component: PlacementSearchComponent },
        { path: ':placementId', title: $localize`Product placement`, component: PlacementEditComponent },
      ]},
      { path: 'settings', title: $localize`Settings`, component: SettingsComponent, children: [
        { path: 'users', title: $localize`Users`, component: UsersComponent },
        { path: 'users/:userId', title: $localize`User`, component: UsersEditComponent },
        { path: 'billing', title: $localize`Billing`, component: BillingComponent },
        { path: 'organization', title: $localize`Billing`, component: OrganizationComponent },
      ]}
      /*
      {
        path: 'applicants',
        title: $localize`Applicants`,
        component: ApplicantsComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Applicants`, component: ApplicantsRecentComponent },
          { path: 'search', title: $localize`Applicant search`, component: ApplicantsSearchComponent },
          { path: ':applicantId', title: $localize`Applicant`, component: ApplicantsEditComponent }
        ]
      },
      {
        path: 'messages',
        title: $localize`Messages`,
        component: MessagesComponent,
        canActivate: [AuthGuard],
        children: [
          { path: 'contacts/:contactId', title: $localize`Customer messages`, component: CustomerContactMessagesComponent, data: { reduceHeight: '7rem' } },
          { path: 'employees/:employeeId', title: $localize`Partner messages`, component: EmployeeMessagesComponent, data: { reduceHeight: '7rem' } },
          { path: 'sales/:chatId', title: $localize`Sales chat`, component: EmployeeMessagesComponent, data: { reduceHeight: '7rem' } },
        ]
      },
      {
        path: 'tasks',
        title: $localize`Tasks`,
        component: TasksComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Tasks`, component: TaskRecentComponent },
          { path: 'search', title: $localize`Task search`, component: TaskSearchComponent },
          { path: ':taskId', title: $localize`Task search`, component: TaskSearchComponent },
        ]
      },
      {
        path: 'customers/contacts',
        title: $localize`Customer personnel`,
        component: CustomersContactsComponent,
        canActivate: [AdminGuard],
        children: [
          { path: '', title: $localize`Customer personnel`, component: CustomerContactRecentComponent },
          { path: 'search', title: $localize`Customer personnel search`, component: CustomerContactSearchComponent },
          { path: ':contactId', title: $localize`Customer personnel`, component: CustomersContactEditComponent },
        ]
      },
      {
        path: 'customers/organizations',
        title: $localize`Customer organizations`,
        component: CustomerOrganizationsComponent,
        canActivate: [AdminGuard],
        children: [
          { path: '', title: $localize`Customer organizations`, component: CustomerOrganizationsRecentComponent },
          { path: 'search', title: $localize`Customer organization search`, component: CustomerOrganizationsSearchComponent },
          { path: ':organizationId', title: $localize`Customer organization`, component: CustomerOrganizationsEditComponent },
          { path: ':organizationId/pricings/:pricingId', title: $localize`Customer organization pricing`, component: CustomerOrganizationPricingComponent },
        ]
      },
      {
        path: 'customers/keys',
        title: $localize`Customer keys`,
        component: CustomerKeysComponent,
        canActivate: [AdminGuard],
        children: [
          { path: 'search', title: $localize`Customer key search`, component: CustomerKeysSearchComponent },
        ]
      },
      { path: 'customers/map', title: $localize`Customers on a map`, component: CustomersMapComponent },
      {
        path: 'customers',
        title: $localize`Customers`,
        component: CustomersComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Customers`, component: CustomersRecentComponent },
          { path: 'announcements', title: $localize`Customer announcements`, component: CustomersAnnouncementComponent },
          { path: 'announcements/:announcementId', title: $localize`Customer announcement`, component: CustomersAnnouncementEditComponent },
          { path: 'search', title: $localize`Customer search`, component: CustomersSearchComponent },
          { path: ':customerId', title: $localize`Customer`, component: CustomersEditComponent },
          { path: ':customerId/contacts/:contactId', title: $localize`Customer personnel`, component: CustomersContactEditComponent },
          { path: ':customerId/pricings/:pricingId', title: $localize`Customer pricing`, component: CustomersPricingComponent },
        ]
      },
      { path: 'employees/map', title: $localize`Partners on a map`, component: EmployeesMapComponent },
      {
        path: 'employees',
        title: $localize`Partners`,
        component: EmployeesComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Partners`, component: EmployeesRecentComponent },
          { path: 'announcements', title: $localize`Partner announcements`, component: EmployeesAnnouncementComponent },
          { path: 'announcements/:announcementId', title: $localize`Partner announcement`, component: EmployeesAnnouncementEditComponent },
          { path: 'search', title: $localize`Partner search`, component: EmployeesSearchComponent },
          { path: ':employeeId', title: $localize`Partner`, component: EmployeesEditComponent }
        ]
      },
      {
        path: 'partners',
        title: $localize`Partners`,
        component: PartnersComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Partners`, component: PartnersRecentComponent },
          { path: 'search', title: $localize`Partner search`, component: PartnersSearchComponent },
          { path: ':partnerId', title: $localize`Partner`, component: PartnersEditComponent }
        ]
      },
      {
        path: 'equipment',
        title: $localize`Equipment`,
        component: EquipmentComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Equipment`, component: EquipmentRecentComponent },
          { path: 'search', title: $localize`Equipment search`, component: EquipmentSearchComponent },
          { path: 'types', title: $localize`Equipment types`, component: EquipmentTypesComponent },
          { path: 'types/:typeId', title: $localize`Equipment types`, component: EquipmentTypesEditComponent },
          { path: ':equipmentId', title: $localize`Equipment`, component: EquipmentEditComponent }
        ]
      },
      {
        path: 'feedback',
        title: $localize`Feedback`,
        component: FeedbackComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Feedback`, component: FeedbackRecentComponent },
          { path: 'search', title: $localize`Feedback search`, component: FeedbackSearchComponent },
          { path: ':feedbackId', title: $localize`Feedback`, component: FeedbackEditComponent }
        ]
      },
      { path: 'export/customers', title: $localize`Export customers`, canActivate: [AuthGuard, AdminGuard], component: ExportCustomersComponent },
      { path: 'export/employees', title: $localize`Export employees`, canActivate: [AuthGuard, AdminGuard], component: ExportEmployeesComponent },
      { path: 'export/invoices', title: $localize`Export invoices`, canActivate: [AuthGuard, AdminGuard], component: ExportInvoicesComponent },
      { path: 'export/salaries', title: $localize`Export salaries`, canActivate: [AuthGuard, AdminGuard], component: ExportSalariesComponent },
      { path: 'export/subcontractor-invoices', title: $localize`Export subcontractor invoices`, canActivate: [AuthGuard, AdminGuard], component: ExportSubcontractorInvoicesComponent },
      
      { path: 'reporting/shifts', title: $localize`Work shift financials`, canActivate: [AuthGuard, AdminGuard], component: ReportingShiftsComponent },
      { path: 'reporting/salary', title: $localize`Salary report`, canActivate: [AuthGuard, AdminGuard], component: ReportingSalaryComponent },
      { path: 'reporting/invoice', title: $localize`Invoice report`, canActivate: [AuthGuard, AdminGuard], component: ReportingInvoiceComponent },
      { path: 'reporting/profit', title: $localize`Profit report`, canActivate: [AuthGuard, AdminGuard], component: ReportingProfitComponent },
      { path: 'reporting/user', title: $localize`User report`, canActivate: [AuthGuard, AdminGuard], component: ReportingUserComponent },
      
      {
        path: '',
        title: $localize`Accounting partners`,
        component: AccountingComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          { path: 'partners', title: $localize`Acounting partners`, component: AccountingPartnersComponent },
          { path: 'partners/:accountingPartnerId', title: $localize`Acounting partners`, component: AccountingPartnersEditComponent },
          { path: 'products', title: $localize`Acounting products`, component: AccountingProductsComponent },
          { path: 'products/recent', title: $localize`Acounting products`, component: AccountingProductsRecentComponent },
          { path: 'products/search', title: $localize`Acounting products`, component: AccountingProductsSearchComponent },
          { path: 'products/:accountingProductId', title: $localize`Acounting products`, component: AccountingProductsEditComponent },
          { path: 'users', title: $localize`Acounting users`, component: AccountingUsersComponent },
          { path: 'users/:accountingUserId', title: $localize`Acounting users`, component: AccountingUsersEditComponent },
        ]
      },
      
      {
        path: 'settings/import',
        title: $localize`Import data`,
        component: SettingsImportComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          { path: 'applicants', title: $localize`Import applicants from CSV`, component: SettingsImportApplicantsComponent },
          { path: 'customers', title: $localize`Import customers from CSV`, component: SettingsImportCustomersComponent },
          { path: 'customer-contacts', title: $localize`Import customer personnel from CSV`, component: SettingsImportCustomerContactsComponent },
          { path: 'customer-organizations', title: $localize`Import customer organizations from CSV`, component: SettingsImportCustomerOrganizationsComponent },
          { path: 'employees', title: $localize`Import employees from CSV`, component: SettingsImportEmployeesComponent },
          { path: 'shifts', title: $localize`Import work shifts from CSV`, component: SettingsImportShiftsComponent },
          { path: 'balance_ge/customer-organizations', title: $localize`Import customer organizations from Balance.ge`, component: SettingsImportBalanceGeCustomerOrganizationsComponent },
          { path: 'balance_ge/employees', title: $localize`Import employees from Balance.ge`, component: SettingsImportBalanceGeEmployeesComponent },
        ]
      },
      {
        path: 'settings/legal',
        title: $localize`Legal`,
        component: LegalComponent,
        children: [
          { path: 'privacy-policy', title: $localize`Privacy policy`, component: PrivacyPolicyComponent },
          { path: 'dpo', title: $localize`Data Protection Officer`, component: DpoComponent },
          { path: 'data-processing-partners', title: $localize`Data processing partners`, component: DataProcessingPartnersComponent },
          { path: 'attributions', title: $localize`Attributions`, component: AttributionsComponent },
        ]
      },
      {
        path: 'settings/translations',
        title: $localize`Translations`,
        component: TranslationsComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          { path: 'assignment/:assignmentId', title: $localize`Work assignment`, component: AssignmentsEditComponent },
          { path: 'message-template/:templateId', title: $localize`Message template`, component: MessageTemplatesEditComponent },
          { path: 'product/:productId', title: $localize`Product`, component: SettingsProductsEditComponent },
          { path: 'prompt/:promptId', title: $localize`AI prompt`, component: PromptEditComponent },
        ]
      },
      {
        path: 'settings/organization',
        title: $localize`Organization settings`,
        component: OrganizationComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          { path: 'prompts', title: $localize`AI agents`, component: PromptsComponent },
          { path: 'prompts/:promptId', title: $localize`AI agent`, component: PromptEditComponent },
          { path: 'general', title: $localize`General settings`, component: GeneralComponent },
          { path: 'holidays', title: $localize`Holiday dates`, component: HolidaysComponent },
          { path: 'holidays/:holidayId', title: $localize`Holiday date`, component: HolidaysEditComponent },
          { path: 'message-templates', title: $localize`Message templates`, component: MessageTemplatesComponent },
          { path: 'message-templates/:templateId', title: $localize`Message template`, component: MessageTemplatesEditComponent },
          { path: 'customer-groups', title: $localize`Customer groups`, component: CustomerGroupsComponent },
          { path: 'customer-groups/:groupId', title: $localize`Customer group`, component: CustomerGroupsEditComponent },
          { path: 'employee-groups', title: $localize`Partner groups`, component: EmployeeGroupsComponent },
          { path: 'employee-groups/:groupId', title: $localize`Partner group`, component: EmployeeGroupsEditComponent },
          { path: 'customer-documents', title: $localize`Customer documents`, component: CustomerDocumentsComponent },
          { path: 'customer-documents/:documentId', title: $localize`Edit customer document`, component: CustomerDocumentEditComponent },
          { path: 'employee-documents', title: $localize`Partner documents`, component: EmployeeDocumentsComponent },
          { path: 'employee-documents/:documentId', title: $localize`Edit partner document`, component: EmployeeDocumentEditComponent },
          { path: 'partner-documents', title: $localize`Partner documents`, component: PartnerDocumentsComponent },
          { path: 'partner-documents/:documentId', title: $localize`Edit partner document`, component: PartnerDocumentEditComponent },
          { path: 'shift-documents', title: $localize`Work shift documents`, component: ShiftDocumentsComponent },
          { path: 'shift-documents/:documentId', title: $localize`Edit work shift document`, component: ShiftDocumentEditComponent },
          { path: 'areas', title: $localize`Working areas`, component: AreasComponent },
          { path: 'areas/:areaId', title: $localize`Working area`, component: AreasEditComponent },
          { path: 'badges', title: $localize`Partner badges`, component: BadgesComponent },
          { path: 'badges/:badgeId', title: $localize`Partner badge`, component: BadgesEditComponent },

          { path: 'cities', title: $localize`Cities`, component: CitiesComponent },
          { path: 'cities/:cityId', title: $localize`City`, component: CitiesEditComponent },

          { path: 'assignments', title: $localize`Work assignments`, component: AssignmentsComponent },
          { path: 'assignments/:assignmentId', title: $localize`Work assignment`, component: AssignmentsEditComponent },
          { path: 'pricings', title: $localize`Pricing`, component: PricingsComponent },
          { path: 'pricings/:pricingId', title: $localize`Pricing`, component: PricesEditComponent },
          { path: 'salary-rules', title: $localize`Salary rules`, component: SalaryRulesComponent },
          { path: 'salary-rules/:salaryRuleId', title: $localize`Salary rules`, component: SalaryRulesEditComponent },
          { path: 'salary-rules/:salaryRuleId/rulesets/:rulesetId', title: $localize`Salary ruleset`, component: SalaryRulesEditRulesetComponent },
          { path: 'salary-rules/:salaryRuleId/rulesets/:rulesetId/rules/:ruleId', title: $localize`Salary rule`, component: SalaryRulesEditRulesetRuleComponent },
          { path: 'skill-groups', title: $localize`Skill and requirement groups`, component: SkillGroupsComponent },
          { path: 'skill-groups/:groupId', title: $localize`Skill and requirement group`, component: SkillGroupsEditComponent },
          { path: 'skills', title: $localize`Skills and requirements`, component: SkillsComponent },
          { path: 'skills/:skillId', title: $localize`Skill and requirement`, component: SkillsEditComponent },
        ]
      },
      {
        path: 'settings/products',
        title: $localize`Products`,
        component: SettingsProductsComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          { path: '', title: $localize`Products`, component: SettingsProductsRecentComponent },
          { path: 'assignments', title: $localize`Work assignments`, component: AssignmentsComponent },
          { path: 'assignments/:assignmentId', title: $localize`Work assignment`, component: AssignmentsEditComponent },
          { path: 'pricings', title: $localize`Pricings`, component: PricingsComponent },
          { path: 'pricings/:pricingId', title: $localize`Pricing`, component: PricesEditComponent },
          { path: 'requests', title: $localize`Product requests`, component: SettingsProductsRequestsComponent },
          { path: 'search', title: $localize`Product search`, component: SettingsProductsSearchComponent },
          { path: ':productId', title: $localize`Product`, component: SettingsProductsEditComponent }
        ]
      },
      {
        path: 'settings/app-builder',
        title: $localize`App builder`,
        component: AppBuilderComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          { path: 'settings', title: $localize`App builder settings`, component: AppBuilderSettingsComponent },
          { path: 'designer', title: $localize`App builder designer`, component: AppBuilderDesignerComponent },
          { path: 'builder', title: $localize`App builder build tool`, component: AppBuilderBuilderComponent },
        ]
      },
      {
        path: 'settings/users',
        title: $localize`Users`,
        component: UsersComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          { path: '', title: $localize`Users`, component: UsersRecentComponent },
          { path: 'search', title: $localize`User search`, component: UsersSearchComponent },
          { path: ':userId', title: $localize`User`, component: UsersEditComponent }
        ]
      },
      { path: 'shifts/calendar', title: $localize`Work shift calendar`, component: ShiftsCalendarComponent },
      { path: 'shifts/map', title: $localize`Current work shifts on a map`, component: ShiftsMapComponent },
      {
        path: 'shifts',
        title: $localize`Work shifts`,
        component: ShiftsComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', title: $localize`Work shifts`, component: ShiftsRecentComponent },
          { path: 'repeat', title: $localize`Repeat work shift`, component: ShiftsRepeatComponent },
          { path: 'repeat/:repeatId', title: $localize`Repeat work shift`, component: ShiftsRepeatComponent },
          { path: 'search', title: $localize`Work shift search`, component: ShiftsSearchComponent },
          { path: ':shiftId', title: $localize`Work shift`, component: ShiftsEditComponent }
        ]
      },
      { path: 'profile', title: $localize`Profile`, component: ProfileComponent, canActivate: [AuthGuard] }
      */
    ]
  }
  //{ path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
